import React, { lazy } from 'react';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  photo: 'https://randomuser.me/api/portraits/women/44.jpg',
  name: 'Mariana Solís',
  location: 'Ciudad de México',
  stars: 5,
  text: 'Llevaba 3 años intentando ser constante. Empezaba fuerte y a los 10 días todo se derrumbaba. Con el Sistema AntiCaos PRO™ entendí por qué fallaba siempre — no era falta de voluntad, era falta de estructura. Hoy llevo 4 meses sin romper mi rutina. Algo que nunca había logrado en mi vida.'
}, {
  photo: 'https://randomuser.me/api/portraits/men/32.jpg',
  name: 'Carlos Mendoza',
  location: 'Bogotá, Colombia',
  stars: 5,
  text: 'Soy papá de dos hijos, trabajo doble turno y creía que la disciplina era un lujo que no me podía dar. El protocolo de 30 días me mostró que no necesito horas libres, necesito un sistema. En 6 semanas bajé 6 kilos, leo 20 minutos al día y duermo mejor. Mi esposa dice que soy otra persona.'
}, {
  photo: 'https://randomuser.me/api/portraits/women/68.jpg',
  name: 'Valentina Ríos',
  location: 'Buenos Aires, Argentina',
  stars: 5,
  text: 'Las meditaciones guiadas me cambiaron la vida. Yo era de las que se castigaba horrible cada vez que fallaba — y ese ciclo de culpa me hundía más. Ahora cuando fallo, sé exactamente cómo volver. Sin drama, sin espiral. El workbook lo tengo lleno de notas. Vale cada centavo y más.'
}];
export function TestimonialSection() {
  return <Section className="bg-transparent" data-id="element-202">
      <div className="max-w-5xl mx-auto" data-id="element-203">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-204">
          <p className="text-[#D4AF37] text-sm font-semibold uppercase tracking-widest mb-3" data-id="element-205">
            Resultados reales
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-white drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]" data-id="element-206">
            Lo que dicen quienes ya lo viven
          </h2>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-207">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex flex-col p-6 rounded-2xl bg-black/50 backdrop-blur-md border border-[#D4AF37]/20 shadow-xl" data-id="element-208">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-209">
                {Array.from({
              length: t.stars
            }).map((_, i) => <Star key={i} className="w-4 h-4 text-[#D4AF37] fill-[#D4AF37]" data-id="element-210" />)}
              </div>

              {/* Quote */}
              <p className="text-gray-200 leading-relaxed text-sm md:text-base flex-1 mb-6 italic" data-id="element-211">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-[#D4AF37]/10" data-id="element-212">
                <img src={t.photo} alt={t.name} loading="lazy" className="w-11 h-11 rounded-full object-cover border-2 border-[#D4AF37]/30" data-id="element-213" />
                <div data-id="element-214">
                  <p className="text-white font-semibold text-sm" data-id="element-215">{t.name}</p>
                  <p className="text-gray-500 text-xs" data-id="element-216">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}